// Copyright (c) 2016 Deere & Company

import SearchFilters from '../state/search-filters';
import actions from '../actions-list';

const updateListFilterBy = (state, action, State) =>
    State === action.state ?
        SearchFilters.update(state, {
            filterBy: {
                $set: action.data
            }
        }) :
        state;

const updateListSortBy = (state, action, State) =>
    State === action.state ?
        SearchFilters.update(state, {
            sortBy: {
                $set: action.data
            }
        }) :
        state;

const updateListSortDirection = (state, action, State) =>
    State === action.state ?
        SearchFilters.update(state, {
            sortDirection: {
                $set: action.data
            }
        }) :
        state;

export default {
    [actions.UPDATE_LIST_FILTER_BY]: updateListFilterBy,
    [actions.UPDATE_LIST_SORT_BY]: updateListSortBy,
    [actions.UPDATE_LIST_SORT_DIRECTION]: updateListSortDirection
};



// WEBPACK FOOTER //
// ./src/shared/reducers/search-filters.js